import React, { useState } from "react";
import axios from "axios";
import { useAuth } from "../../../contexts/AuthContext";
import { toast } from "react-toastify"; // 👈 اضافه شد

const StopTrackingLoginForm = ({ availableLogins = [], refetchConfigs }) => { // 👈 refetchConfigs اضافه شد
  const [formData, setFormData] = useState({
    target: "groups",
    login: "",
    reason: "",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const { apiBaseUrl } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      const payload = {
        target: formData.target,
        login: formData.login,
        reason: formData.reason,
      };

      const response = await axios.post(
        `${apiBaseUrl}/api/admin/final/accounts/trading/login/untrack`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      if (response.data.success || response.data.ok) {
        const successMessage = "ردیابی لاگین با موفقیت متوقف شد";
        setMessage(successMessage);
        toast.success(successMessage); // 👈 اضافه شد
        
        setFormData({
          target: "individuals",
          login: "",
          reason: "",
        });
        
        // 👇 refetch configs بعد از موفقیت
        if (refetchConfigs) {
          await refetchConfigs();
        }
      }
    } catch (error) {
      console.error("Error:", error);
      const errorMessage = error.response?.data?.message || "خطا در ارسال درخواست";
      setMessage(errorMessage);
      toast.error(errorMessage); // 👈 اضافه شد
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="space-y-6 p-6">
      <div className="bg-red-900/20 border border-red-600 rounded-lg p-4 mb-6">
        <h3 className="text-xl font-semibold text-white mb-2 flex items-center gap-2">
          <span>⛔</span> توقف ردیابی لاگین
        </h3>
        <p className="text-red-300 text-sm">
          متوقف کردن نظارت و ردیابی یک حساب خاص
        </p>
      </div>

      {message && (
        <div
          className={`p-4 rounded-lg text-center ${
            message.includes("موفقیت")
              ? "bg-green-900 border border-green-600 text-green-400"
              : "bg-red-900 border border-red-600 text-red-400"
          }`}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Target Selection */}
        <div className="bg-gray-800 border border-gray-600 rounded-lg p-4">
          <label className="block text-white font-medium mb-3">
            انتخاب نوع حساب (Target):
          </label>
          <div className="flex gap-4">
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="individuals"
                checked={formData.target === "individuals"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Individuals (حساب‌های فردی)</span>
            </label>
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="radio"
                name="target"
                value="groups"
                checked={formData.target === "groups"}
                onChange={(e) =>
                  setFormData({ ...formData, target: e.target.value })
                }
                className="w-5 h-5 accent-blue-600"
              />
              <span className="text-white">Groups (گروه‌ها)</span>
            </label>
          </div>
        </div>

        {/* Login Field */}
        <div>
          <label className="block text-white font-medium mb-2">
            شماره Login <span className="text-red-400">*</span>
          </label>

          {availableLogins.length > 0 ? (
            <>
              <select
                value={formData.login}
                onChange={(e) =>
                  setFormData({ ...formData, login: e.target.value })
                }
                className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white focus:border-red-500 focus:outline-none mb-2"
              >
                <option value="">انتخاب از لیست یا وارد کردن دستی...</option>
                {availableLogins.map((loginObj) => (
                  <option key={loginObj.login} value={loginObj.login}>
                    {loginObj.login}
                    {loginObj.name && ` - ${loginObj.name}`}
                    {` (${loginObj.isActive ? "فعال" : "غیرفعال"})`}
                  </option>
                ))}
              </select>
              <p className="text-gray-400 text-xs mb-2">یا وارد کنید:</p>
            </>
          ) : null}

          <input
            type="text"
            value={formData.login}
            onChange={(e) =>
              setFormData({ ...formData, login: e.target.value })
            }
            placeholder="شماره Login را وارد کنید"
            className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-red-500 focus:outline-none"
            required
          />
        </div>

        {/* Reason Field */}
        <div>
          <label className="block text-white font-medium mb-2">
            دلیل توقف ردیابی <span className="text-red-400">*</span>
          </label>
          <textarea
            value={formData.reason}
            onChange={(e) =>
              setFormData({ ...formData, reason: e.target.value })
            }
            placeholder="لطفاً دلیل توقف ردیابی این حساب را توضیح دهید..."
            rows="4"
            className="w-full p-3 bg-gray-800 border border-gray-600 rounded-lg text-white placeholder-gray-400 focus:border-red-500 focus:outline-none resize-none"
            required
          />
        </div>

        {/* Warning */}
        <div className="bg-yellow-900/20 border border-yellow-600 rounded-lg p-4">
          <div className="flex items-start gap-3">
            <span className="text-yellow-400 text-2xl">⚠️</span>
            <div>
              <h4 className="text-yellow-400 font-medium mb-1">هشدار</h4>
              <p className="text-gray-300 text-sm">
                با توقف ردیابی، این حساب دیگر توسط سیستم نظارت نخواهد شد
              </p>
            </div>
          </div>
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          disabled={loading || !formData.login || !formData.reason.trim()}
          className="w-full py-4 px-6 bg-red-600 hover:bg-red-700 disabled:bg-gray-600 text-white font-bold text-lg rounded-lg transition duration-200 flex items-center justify-center gap-3 shadow-lg"
        >
          {loading ? (
            <>
              <div className="animate-spin rounded-full h-6 w-6 border-3 border-white border-t-transparent"></div>
              در حال ارسال...
            </>
          ) : (
            <>
              <span>⛔</span>
              توقف ردیابی
            </>
          )}
        </button>
      </form>
    </div>
  );
};

export default StopTrackingLoginForm;